import {UserType} from '@legit-health/ui';

export default function isPractitionerType(type: string) {
  return type === UserType.Practitioner;
}
